import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-simah-approve',
  templateUrl: './simahapprove.component.html',
  styleUrls: ['./simahapprove.component.css']
})
export class SimahApproveComponent {
  @Input() FundId!: string;

  form: FormGroup; 
  isArabic: boolean = true;
  isCustomerConsentedForBayan: boolean = false;
  loading = false;
  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      approve: [false, Validators.requiredTrue] 
    });
  }
  onSubmit() {
    if (this.form.valid) {
      const payload = {
        ...this.form.value
      };
    }
  }
}
